module.exports = __webpack_public_path__ + "static/img/29.4ea282ac.png";